import React from 'react';
import SiteHeader from '~/shared/SiteHeader.jsx';
import { SiteFooter } from '~/shared/SiteFooter.jsx';

/*
  The public pages' frame: the site's one header and one footer. Both moved to
  `shared/` on 2026-10-30, when the public pages and the app started sharing
  them — the header's links follow whether the reader is signed in, not which
  page this is. See `shared/SiteHeader.jsx`.
*/
export default function MarketingLayout({ children }) {
  return (
    <>
      <SiteHeader />
      {children}
      <SiteFooter />
    </>
  );
}

export const withMarketingLayout = (page) => <MarketingLayout>{page}</MarketingLayout>;
